import { lazy, Suspense } from "react";
import TextField from "@/components/common/GoogleTextField";

const MapsInputActual = lazy(() =>
  import("./MapsInputActual").then((m) => ({ default: m.MapsInput })),
);

interface AddressData {
  addressLine: string;
  city: string;
  state: string;
  stateCode: string;
  country: string;
  countryCode: string;
  pinCode: string;
}

interface MapsInputProps {
  id?: string;
  value?: string;
  onChange: (address: AddressData) => void;
  /** Enables manual entry in the same field, even without Google Maps. */
  onInputChange?: (value: string) => void;
  helperText?: string;
  required?: boolean;
  placeholder?: string;
  className?: string;
  disabled?: boolean;
  enableGps?: boolean;
}

export function MapsInput(props: MapsInputProps) {
  return (
    <Suspense
      fallback={
        <TextField
          id={props.id}
          value={props.value ?? ""}
          placeholder={props.placeholder}
          onChange={(event) => props.onInputChange?.(event.target.value)}
          disabled={props.disabled || !props.onInputChange}
          required={props.required}
          helperText={props.helperText}
          fullWidth
          size="small"
        />
      }
    >
      <MapsInputActual {...props} />
    </Suspense>
  );
}
